import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { _Char___init__impl__6a9atx1csff5kwtduxl as _Char___init__impl__6a9atx } from '../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import {
  indexOf1xbs558u7wr52 as indexOf,
  trim11nh7r46at6sx as trim,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import {
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  toString1pkumu07cwy4m as toString,
  equals2au1ep9vhcato as equals,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  substringiqarkczpya5m as substring,
  substring3saq8ornu0luv as substring_0,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/text/stringJs.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { isCharSequence1ju9jr1w86plq as isCharSequence } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { HttpHeader1d7ldebjomr00 as HttpHeader } from '../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/http/Http.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  fromInt2ii0rejb1w62w as fromInt,
  subtract2orl8z9upxd9l as subtract,
  add2suhfggl4zvkk as add,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { Buffer3384y49aj0pxr as Buffer } from '../../../../../okio-parent-okio/okio/Buffer.mjs';
import { Companion_instance35rvxj4aba79n as Companion_instance } from '../../../../../okio-parent-okio/okio/Options.mjs';
import { Companion_getInstance28gds36m4006o as Companion_getInstance } from '../../../../../okio-parent-okio/okio/ByteString.mjs';
import { DefaultApolloException8w3ielfxng0h as DefaultApolloException } from '../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/exception/Exceptions.mjs';
import { bufferbiiev5vr4b6f as buffer } from '../../../../../okio-parent-okio/okio/Okio.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function readHeaders($this, source) {
  // Inline function 'kotlin.collections.mutableListOf' call
  var headers = ArrayList().u2();
  $l$loop: while (true) {
    var line = source.e3y();
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(line) === 0)
      break $l$loop;
    var index = indexOf(line, _Char___init__impl__6a9atx(58));
    // Inline function 'kotlin.check' call
    if (!!(index === -1)) {
      var message = 'Unexpected header: ' + line;
      throw IllegalStateException().o(toString(message));
    }
    // Inline function 'kotlin.text.trim' call
    var this_0 = substring(line, 0, index);
    var tmp = toString(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
    // Inline function 'kotlin.text.trim' call
    var this_1 = substring_0(line, index + 1 | 0);
    var tmp$ret$5 = toString(trim(isCharSequence(this_1) ? this_1 : THROW_CCE()));
    // Inline function 'kotlin.collections.plusAssign' call
    var element = new (HttpHeader())(tmp, tmp$ret$5);
    headers.n2(element);
  }
  return headers;
}
var PartSourceClass;
function PartSource() {
  if (PartSourceClass === VOID) {
    class $ {
      constructor($outer) {
        this.w65_1 = $outer;
      }
      q6() {
        if (equals(this.w65_1.e66_1, this)) {
          this.w65_1.e66_1 = null;
        }
      }
      r3y(sink, byteCount) {
        // Inline function 'kotlin.require' call
        if (!(byteCount >= 0n)) {
          var message = 'byteCount < 0: ' + byteCount.toString();
          throw IllegalArgumentException().s2(toString(message));
        }
        // Inline function 'kotlin.check' call
        if (!equals(this.w65_1.e66_1, this)) {
          var message_0 = 'closed';
          throw IllegalStateException().o(toString(message_0));
        }
        var limit = currentPartBytesRemaining(this.w65_1, byteCount);
        return limit === 0n ? -1n : this.w65_1.x65_1.r3y(sink, limit);
      }
    }
    initMetadataForClass($, 'PartSource');
    PartSourceClass = $;
  }
  return PartSourceClass;
}
function currentPartBytesRemaining($this, maxResult) {
  $this.x65_1.p3x(fromInt($this.a66_1.v2()));
  var delimiterIndex = $this.x65_1.n3x().s3y($this.a66_1);
  var tmp;
  if (delimiterIndex === -1n) {
    var tmp0 = $this.x65_1.n3x().x3u_1;
    // Inline function 'kotlin.Long.minus' call
    var other = $this.a66_1.v2();
    // Inline function 'kotlin.Long.plus' call
    var this_0 = subtract(tmp0, fromInt(other));
    // Inline function 'kotlin.comparisons.minOf' call
    var b = add(this_0, fromInt(1));
    tmp = maxResult <= b ? maxResult : b;
  } else {
    // Inline function 'kotlin.comparisons.minOf' call
    tmp = maxResult <= delimiterIndex ? maxResult : delimiterIndex;
  }
  return tmp;
}
var PartClass;
function Part() {
  if (PartClass === VOID) {
    class $ {
      constructor(headers, body) {
        this.g66_1 = headers;
        this.h66_1 = body;
      }
      q6() {
        this.h66_1.q6();
      }
    }
    initMetadataForClass($, 'Part');
    PartClass = $;
  }
  return PartClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {}
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance_0;
function Companion_getInstance_0() {
  return Companion_instance_0;
}
var MultipartReaderClass;
function MultipartReader() {
  if (MultipartReaderClass === VOID) {
    class $ {
      constructor(source, boundary) {
        this.x65_1 = source;
        this.y65_1 = boundary;
        this.z65_1 = (new (Buffer())()).n3y('--').n3y(this.y65_1).z3x();
        this.a66_1 = (new (Buffer())()).n3y('\r\n--').n3y(this.y65_1).z3x();
        this.b66_1 = 0;
        this.c66_1 = false;
        this.d66_1 = false;
        this.e66_1 = null;
        this.f66_1 = Companion_instance.e3v([Companion_getInstance().t3w('\r\n--' + this.y65_1 + '--'), Companion_getInstance().t3w('\r\n'), Companion_getInstance().t3w('--'), Companion_getInstance().t3w(' '), Companion_getInstance().t3w('\t')]);
      }
      i66() {
        // Inline function 'kotlin.check' call
        if (!!this.c66_1) {
          var message = 'closed';
          throw IllegalStateException().o(toString(message));
        }
        if (this.d66_1)
          return null;
        if (this.b66_1 === 0 && this.x65_1.w3y(0n, this.z65_1)) {
          this.x65_1.y3u(fromInt(this.z65_1.v2()));
        } else {
          $l$loop: while (true) {
            var toSkip = currentPartBytesRemaining(this, 8192n);
            if (toSkip === 0n)
              break $l$loop;
            this.x65_1.y3u(toSkip);
          }
          this.x65_1.y3u(fromInt(this.a66_1.v2()));
        }
        var whitespace = false;
        afterBoundaryLoop: while (true) {
          switch (this.x65_1.h3y(this.f66_1)) {
            case 0:
              if (this.b66_1 === 0)
                throw DefaultApolloException().m44('expected at least 1 part');
              this.d66_1 = true;
              return null;
            case 1:
              this.b66_1 = this.b66_1 + 1 | 0;
              break afterBoundaryLoop;
            case 2:
              if (whitespace)
                throw DefaultApolloException().m44('unexpected characters after boundary');
              if (this.b66_1 === 0)
                throw DefaultApolloException().m44('expected at least 1 part');
              this.d66_1 = true;
              return null;
            case 3:
            case 4:
              whitespace = true;
              continue afterBoundaryLoop;
            case -1:
              if (this.x65_1.o3x()) {
                throw DefaultApolloException().m44('premature end of multipart body');
              } else {
                throw DefaultApolloException().m44('unexpected characters after boundary');
              }

          }
        }
        var headers = readHeaders(Companion_instance_0, this.x65_1);
        var partSource = new (PartSource())(this);
        this.e66_1 = partSource;
        return new (Part())(headers, buffer(partSource));
      }
      q6() {
        if (this.c66_1)
          return Unit_instance;
        this.c66_1 = true;
        this.e66_1 = null;
        this.x65_1.q6();
      }
    }
    initMetadataForClass($, 'MultipartReader');
    MultipartReaderClass = $;
  }
  return MultipartReaderClass;
}
//region block: init
Companion_instance_0 = new (Companion())();
//endregion
//region block: exports
export {
  MultipartReader as MultipartReader25md2ukkr9jti,
};
//endregion

//# sourceMappingURL=MultipartReader.mjs.map
